<template>
  <v-navigation-drawer v-model="drawer" app id="navDrawer" temporary @transitionend="refreshMenuItems">
    <v-list class="pa-1" color="primary--text">
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar size="25" class="mr-4 d-inline-flex">
            <img :src="profilePicture" v-if="getLoggedInUser.profilePicture" />
            <b-icon v-if="!getLoggedInUser.profilePicture" icon="person-fill"></b-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ getLoggedInUser.firstName }} {{ getLoggedInUser.lastName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list class="pt-0" dense flat color="primary--text">
      <v-list-item-group>
        <v-divider></v-divider>
        <v-list-item :to="{ name: 'home' }" exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.home") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item :to="{ name: 'users' }" exact @click="drawer = false" v-if="isAdmin">
          <v-list-item-icon><v-icon>mdi-account</v-icon> </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.usersAdministration") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- <v-list-item exact @click="drawer = false">
            <v-list-item-icon>
              <v-icon>book</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('nav.DPRAdmin') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

        <v-list-group prepend-icon="book" v-if="isDprPresent">
          <template v-slot:activator>
            <v-list-item-title>{{ $t("nav.DPRAdmin") }}</v-list-item-title>
          </template>

          <v-list-item v-for="item in itemsVessel" :key="item.title" :to="{ name: item.to, query: { pclsd: isProjectClosed } }">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>

        <v-list-group prepend-icon="settings" v-if="isMasterDataAdmin">
          <template v-slot:activator>
            <v-list-item-title>{{ $t("nav.masterdata") }}</v-list-item-title>
          </template>

          <v-list-item v-for="item in masterDataMenuItems" :key="item.title" :to="{ name: item.to }">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>

        <v-list-group prepend-icon="settings_suggest" v-if="isMasterDataAdmin">
          <template v-slot:activator>
            <v-list-item-title>{{ $t("nav.masterdatageneric") }}</v-list-item-title>
          </template>

          <v-list-item v-for="item in itemsGeneric" :key="item.title" :to="{ name: item.to }">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'localComputerAssignment' }" exact @click="drawer = false" v-if="isMasterDataAdmin">
          <v-list-item-icon>
            <v-icon>directions_boat</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.localInstallation") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'DPROutput' }" exact @click="drawer = false" v-if="isMasterDataAdmin">
          <v-list-item-icon>
            <v-icon>book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.DPROutput") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'logos' }" exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.logos") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>info</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.manuals") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'userprofile' }" exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.myaccount") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'errorLog' }" exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-list</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.errorLog") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item :to="{ name: 'translations' }" exact @click="drawer = false">
          <v-list-item-icon>
            <v-icon>mdi-translate</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.translations") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item v-if="getLoggedIn" @click="logout">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("common.logout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
var userRole = require("../store/modules/user-role/user-roles");

export default {
  props: ["value"],
  data() {
    return {
      items: [
        { title: "nav.vessels", to: "vessels", icon: "", restricted: true, roles: [userRole.REPORTING_ADMIN_ROLE] },
        { title: "nav.projects", to: "project", icon: "", restricted: true, roles: [userRole.REPORTING_ADMIN_ROLE] },
        { title: "nav.activities", to: "activities", icon: "" },
        { title: "nav.macroActMaster", to: "macroActMaster", icon: "" },
        { title: "nav.activityMaster", to: "activityMaster", icon: "" },
        { title: "nav.cables", to: "cables", icon: "" },
        { title: "nav.areaMasterMenu", to: "areaMaster", icon: "" },
        { title: "nav.configMaster", to: "configMaster", icon: "" },
        { title: "nav.QHSEMaster", to: "QHSEMaster", icon: "" },
        { title: "nav.protectionMethodology", to: "protectionMethodology", icon: "" },
        { title: "nav.soil", to: "soil", icon: "" },
        { title: "nav.estimates", to: "estimates", icon: "" },
        { title: "nav.equipStatus", to: "equipStatus", icon: "" },
        { title: "nav.progressAnalysis", to: "progressAnalysis", icon: "" },
        { title: "nav.pdfConf", to: "pdfConfigurations", icon: "" },
      ],
      itemsGeneric: [
        { title: "nav.activityCategory", to: "activityCategory", icon: "" },
        { title: "nav.activityType", to: "activityType", icon: "" },
        { title: "nav.tools", to: "tools", icon: "" },
        { title: "nav.rankList", to: "rankList", icon: "" },
        { title: "nav.lines", to: "lines", icon: "" },
      ],
      itemsVessel: [
        {
          title: "DPR Header",
          to: "dprHeader",
          icon: "",
          dprRequired: true,
        },
        {
          title: "vesselMenu.actW",
          to: "actWeather",
          icon: "",
          dprRequired: true,
        },
        {
          title: "vesselMenu.status",
          to: "status",
          icon: "",
          dprRequired: true,
        },
        {
          title: "vesselMenu.comments",
          to: "comments",
          icon: "",
          dprRequired: true,
        },
        {
          title: "vesselMenu.lists",
          to: "lists",
          icon: "",
          dprRequired: true,
        },
        {
          title: "vesselMenu.signOff",
          to: "signOff",
          icon: "",
          dprRequired: true,
        },
      ],
      isDprPresent: false,
      ndd: null,
    };
  },
  computed: {
    ...mapGetters(["getLoggedInUser", "getLoggedIn", "isAdmin", "mv_dprData/getCurrentDprMainId"]),

    isMasterDataAdmin() {
      let roleName = this.getLoggedInUser.roleName;
      return [userRole.REPORTING_ADMIN_ROLE, userRole.PROJECT_ADMIN_ROLE].indexOf(roleName) !== -1;
    },

    isClientViewer() {
      return userRole.CLIENT_VIEWER_ROLE == this.getLoggedInUser.roleName;
    },

    profilePicture() {
      if (!this.getLoggedInUser) {
        return null;
      }

      let pp = this.getLoggedInUser.profilePicture;
      if (!pp || pp.indexOf("data:image") !== -1) {
        return this.getLoggedInUser.profilePicture;
      }

      return "data:image/png;base64," + this.getLoggedInUser.profilePicture;
    },

    masterDataMenuItems() {
      let userRole = this.getLoggedInUser.roleName;
      return this.items.filter((item) => !item.restricted || (item.restricted && item.roles.indexOf(userRole) !== -1));
    },

    drawer: {
      get() {
        return this.ndd;
      },
      set(value) {
        this.ndd = value;
        this.$emit("input", value);
      },
    },

    isProjectClosed() {
      return this.$route.query.pclsd;
    },
  },

  methods: {
    ...mapActions(["doLogout"]),
    logout() {
      if (this.getLoggedInUser.isOpenIdAuth) location.href = Vue.$href("logout");
      else this.doLogout();
    },
    refreshMenuItems() {
      let dprMainId = this.$route.params.dprMainId;
      this.isDprPresent = null != dprMainId && typeof dprMainId != "undefined";
      this.$nextTick(() => this.$forceUpdate());
    },
  },
  watch: {
    value() {
      this.ndd = this.value;
    },
  },
};
</script>

<style>
.v-list-item:hover {
  background: rgb(243, 240, 240);
}
#navDrawer {
  width: 100%;
  height: 100%;
  align-content: flex-start;
  z-index: 99999;
}
</style>
